import React, { useState } from 'react';
import { Camera, Calendar } from 'lucide-react';

const ProfileHeader = ({ profile, onEditPhoto }) => {
  const initials = profile?.fullName
    ? profile?.fullName?.split(' ')?.map(n => n?.[0])?.join('')?.toUpperCase()?.slice(0, 2)
    : 'U';

  const memberSince = profile?.createdAt
    ? new Date(profile.createdAt)?.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
    : 'Recently';

  return (
    <div className="bg-gradient-to-br from-[#1a365d] to-[#2d5a87] rounded-2xl p-6 text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-40 h-40 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-24 h-24 bg-[#ffd700]/10 rounded-full translate-y-1/2 -translate-x-1/2" />
      <div className="relative flex items-center gap-5">
        <div className="relative flex-shrink-0">
          {profile?.avatarUrl ? (
            <img
              src={profile?.avatarUrl}
              alt={`${profile?.fullName || 'User'} profile photo`}
              className="w-20 h-20 rounded-2xl object-cover border-2 border-[#ffd700]/50"
            />
          ) : (
            <div className="w-20 h-20 rounded-2xl bg-[#ffd700]/20 border-2 border-[#ffd700]/50 flex items-center justify-center">
              <span className="text-2xl font-bold text-[#ffd700]">{initials}</span>
            </div>
          )}
          <button
            onClick={onEditPhoto}
            className="absolute -bottom-1 -right-1 w-7 h-7 bg-[#ffd700] rounded-lg flex items-center justify-center hover:bg-[#fbbf24] transition-colors"
          >
            <Camera className="w-3.5 h-3.5 text-[#1a365d]" />
          </button>
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="text-xl font-bold truncate">{profile?.fullName || 'OnTheGo User'}</h2>
          <p className="text-white/70 text-sm truncate mt-0.5">{profile?.email || ''}</p>
          {profile?.phone && (
            <p className="text-white/60 text-sm truncate">{profile?.phone}</p>
          )}
          <div className="flex items-center gap-1.5 mt-2">
            <Calendar className="w-3.5 h-3.5 text-[#ffd700]" />
            <span className="text-xs text-white/60">Member since {memberSince}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
